/**
 * SlideVariant — picks the right variant file from `slides/registry`.
 *
 * Callers wrap this in <ApplyEntryEffect> (see
 * slides/entry/ApplyEntryEffect) so the entry animation runs once per
 * mount.
 */
import { resolveVariant } from '../registry';
import type { PreviewSlideData } from '../../PreviewSlide';

export function SlideVariant({ slide }: { slide: PreviewSlideData }) {
  const Variant = resolveVariant(slide.type);
  return <Variant slide={slide} />;
}
